import React from 'react'
import { S_ConfirmModal } from '../../../../LenderViews/FundingRequestPage/ConfirmModal'
import { Button } from '../../../../../_components/Button'
import { deleteInvoice } from '../../../../../_services/lender.service'
import { confirmDeleteConstants } from '../constants'

const ConfirmDeleteModal = ({ invoice, closeModal, onRemove }) => {
  const number = invoice?.invoice_number ? ` #${invoice.invoice_number}` : ''
  return (
    <S_ConfirmModal>
      <h2>{confirmDeleteConstants.MODAL_TITLE}</h2>
      <p>{confirmDeleteConstants.MODAL_PARAGRAPH.replace('{number}', number)}</p>
      <div className="actions-row">
        <Button onClick={closeModal} text={confirmDeleteConstants.CANCEL_BUTTON} />
        <Button
          className="destroy"
          onClick={async () => {
            if (invoice.backend_id) {
              await deleteInvoice(invoice.backend_id).then(() => {
                onRemove(invoice.id)
                closeModal()
              })
            } else {
              onRemove(invoice.id)
              closeModal()
            }
          }}
          text={confirmDeleteConstants.CONFIRM_BUTTON}
        />
      </div>
    </S_ConfirmModal>
  )
}
export default ConfirmDeleteModal
